/* People's Peps: behaviour for the sections added 2026-10-07.
   Affiliate estimator: recalculates on input through one delegated listener, so
   it keeps working after the theme editor re-renders a section. Safe to load
   more than once on a page. */
(function () {
  if (window.__ppPages2) return;
  window.__ppPages2 = true;

  var locale = document.documentElement.lang || 'en-US';

  function money(v, cur) {
    try {
      return new Intl.NumberFormat(locale, { style: 'currency', currency: cur || 'USD', minimumFractionDigits: 2, maximumFractionDigits: 2 }).format(v);
    } catch (e) {
      return '$' + v.toFixed(2);
    }
  }

  function calc(root) {
    var rate = parseFloat(root.getAttribute('data-rate')) || 0;
    var cur = root.getAttribute('data-currency') || 'USD';
    var o = root.querySelector('[data-pp-affcalc-orders]');
    var a = root.querySelector('[data-pp-affcalc-aov]');
    var n = Math.max(0, parseFloat(o && o.value) || 0);
    var v = Math.max(0, parseFloat(a && a.value) || 0);
    var month = n * v * rate / 100;
    var out = root.querySelector('[data-pp-affcalc-orders-out]');
    if (out) out.textContent = String(n);
    var m = root.querySelector('[data-pp-affcalc-month]');
    var y = root.querySelector('[data-pp-affcalc-year]');
    if (m) m.textContent = money(month, cur);
    if (y) y.textContent = money(month * 12, cur);
    if (o) {
      var lo = parseFloat(o.min) || 0, hi = parseFloat(o.max) || 100;
      var pct = hi > lo ? (n - lo) / (hi - lo) * 100 : 0;
      o.style.setProperty('--pp-fill', Math.max(0, Math.min(100, pct)) + '%');
    }
  }

  function all() {
    var els = document.querySelectorAll('[data-pp-affcalc]');
    for (var i = 0; i < els.length; i++) calc(els[i]);
  }

  document.addEventListener('input', function (e) {
    var t = e.target;
    var root = t && t.closest ? t.closest('[data-pp-affcalc]') : null;
    if (root) calc(root);
  });
  document.addEventListener('shopify:section:load', all);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', all);
  else all();
})();

/* Page hero lot lookup (band style). The field in the hero hands its value to
   the PP lot lookup section on the same page and scrolls to its answer. With
   no lookup section on the page, the form submits normally as ?lot=. A page
   opened with ?lot= (a link, or the no-JavaScript submit) is looked up on
   arrival. Delegated, so it survives the theme editor re-rendering a section. */
(function () {
  if (window.__ppHeroLookup) return;
  window.__ppHeroLookup = true;

  function panelFor() { return document.querySelector('[data-pp-lot]'); }

  function run(value, scroll) {
    var panel = panelFor();
    if (!panel) return false;
    var input = panel.querySelector('.pp-lot__input');
    var form = panel.querySelector('[data-pp-lot-form]');
    if (!input || !form) return false;
    input.value = value;
    // Only submit once pp-pdp.js has wired the panel; otherwise the browser
    // would submit the form for real and reload the page.
    if (panel.dataset.ppInitLot !== '1') return true;
    if (scroll) {
      var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      try { panel.scrollIntoView({ behavior: reduce ? 'auto' : 'smooth', block: 'center' }); } catch (e) { panel.scrollIntoView(); }
    }
    if (typeof form.requestSubmit === 'function') form.requestSubmit();
    else form.dispatchEvent(new Event('submit', { cancelable: true, bubbles: true }));
    return true;
  }

  document.addEventListener('submit', function (e) {
    var f = e.target;
    if (!f || !f.matches || !f.matches('[data-pp-hero-lookup]')) return;
    var input = f.querySelector('input[name="lot"]');
    var v = input ? input.value.trim() : '';
    if (run(v, true)) e.preventDefault();
  });

  function fromUrl() {
    var v = '';
    try { v = (new URL(window.location.href)).searchParams.get('lot') || ''; } catch (e) { v = ''; }
    v = v.trim();
    if (!v) return;
    var hero = document.querySelector('[data-pp-hero-lookup] input[name="lot"]');
    if (hero) hero.value = v;
    // pp-pdp.js wires the lookup panel on DOMContentLoaded; wait a tick for it.
    window.setTimeout(function () { run(v, true); }, 60);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', fromUrl, { once: true });
  else fromUrl();
})();
